var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInverted12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 98,
    viewBox: "0 0 142 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 38C62 48.4 60.4 57.3333 57.2 64.8C54 72.5333 49.8667 78.8 44.8 83.6C39.7333 88.6667 34 92.2667 27.6 94.4C20.9333 96.8 14.4 98 7.99998 98L7.99998 84C14.9333 84 21.4667 81.6 27.6 76.8C33.4667 72.2667 36.9333 66 38 58C37.2 58.2667 36.2667 58.5333 35.2 58.8C34.4 59.0667 33.4667 59.3333 32.4 59.6C31.0667 59.8667 29.6 60 28 60C20 60 13.3333 56.9333 7.99998 50.8C2.66665 44.9333 -5.24537e-06 38 -5.94475e-06 30C-6.64413e-06 22 2.8 14.9334 8.4 8.80001C13.7333 2.93335 20.9333 1.0584e-05 30 9.79135e-06C40.1333 8.90547e-06 48 3.73334 53.6 11.2C59.2 18.9333 62 27.8667 62 38ZM142 38C142 48.4 140.4 57.3333 137.2 64.8C134 72.5333 129.867 78.8 124.8 83.6C119.733 88.6667 114 92.2667 107.6 94.4C100.933 96.8 94.4 98 88 98L88 84C94.9333 84 101.467 81.6 107.6 76.8C113.467 72.2667 116.933 66 118 58C117.2 58.2667 116.267 58.5333 115.2 58.8C114.4 59.0667 113.467 59.3333 112.4 59.6C111.067 59.8667 109.6 60 108 60C100 60 93.3333 56.9333 88 50.8C82.6667 44.9333 80 38 80 30C80 22 82.8 14.9333 88.4 8.80001C93.7333 2.93335 100.933 3.59016e-06 110 2.79753e-06C120.133 1.91165e-06 128 3.73333 133.6 11.2C139.2 18.9333 142 27.8667 142 38Z",
    fill: "url(#paint0_linear_1_9275)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_9275",
    x1: 71,
    y1: 98,
    x2: 71,
    y2: 0.00000620702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E1E1",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInverted12);
export default __webpack_public_path__ + "static/media/inverted 1 (2).4a12c2250f2f9851293d35153b3600d3.svg";
export { ForwardRef as ReactComponent };